import { useEffect, useState } from "react";

const HRDashboardPage = () => {
  const [currentHour, setCurrentHour] = useState(new Date().getHours());

  useEffect(() => {
    const timer = window.setInterval(() => {
      setCurrentHour(new Date().getHours());
    }, 60000);

    return () => window.clearInterval(timer);
  }, []);

  let greeting = "Good Evening";

  if (currentHour < 12) {
    greeting = "Good Morning";
  } else if (currentHour < 17) {
    greeting = "Good Afternoon";
  }

  return (
    <section className="hr-home-page">
      <section
        className="hr-home-hero"
        style={{
          backgroundImage:
            'linear-gradient(90deg, rgba(3, 7, 18, 0.82), rgba(15, 23, 42, 0.48)), url("/assets/AdminBGI.png")',
        }}
      >
        <div className="hr-home-hero-content">
          <div className="hr-home-greeting">{greeting}, HR Team</div>
          <h1>Welcome to BlackRoth HR Team</h1>
          <p>
            Your complete HR workspace starts here with a focused welcome screen
            for the BlackRoth team.
          </p>
        </div>
      </section>
    </section>
  );
};

export default HRDashboardPage;
 